import { render, staticRenderFns } from "./MultiAssetMediaPreviewOverlay.vue?vue&type=template&id=539057b4&scoped=true"
import script from "./MultiAssetMediaPreviewOverlay.vue?vue&type=script&lang=js"
export * from "./MultiAssetMediaPreviewOverlay.vue?vue&type=script&lang=js"
import style0 from "./MultiAssetMediaPreviewOverlay.vue?vue&type=style&index=0&id=539057b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "539057b4",
  null
  
)

export default component.exports